export default "__VITE_ASSET__DdnldkJo__"